<script>
	import { onMount } from "svelte";

	import { pageNumber, model } from "../../stores";
	import { projectSettings } from "../../config";
	import { registerFormStart } from "../../tealium";

	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";

	export let title = null;
	export let pageIndex = null;
	export let pageTitle = null;
	export let nextPage = null;
	export let lastVisitedPage = null;

	pageNumber.update((p) => pageIndex);
	$model.LastPageVisited = lastVisitedPage;
	document.title = pageTitle;

	//  Get the user Agent
	$model.UserAgent = navigator.userAgent;
	$model.referrer = document.referrer;
	$model.RegistrationSegmentId = null;
</script>

<PageSection>
	<div class="row justify-content-center">
		<div class="col-md-8 col-sm-12">
			<h1 class="text-center">Register for the {projectSettings.classActionName}</h1>
		</div>
	</div>
	<div class="row justify-content-md-center">
		<div class="col-md-8 col-sm-12">
			<!-- <h2 class="text-center">CLASS ACTION REGISTRATION FORM</h2> -->

			<p>To be a part of this class action you must:</p>
			<p>Be a current or former McDonald's employee who has worked shifts of four hours or more:</p>
			<ul>
				<li>in a McDonald's corporate store between 7 December 2015 and 27 May 2022;<br /> AND/OR</li>
				<li>in a McDonald's franchised store between 28 May 2016 and 27 May 2022;<br /> AND</li>
				<li>not have been given 10 minute breaks during one or more of these shifts;<br /> AND</li>
				<li>
					have not claimed in other Court proceedings, whether through an agent or representative or
					otherwise, the same or similar relief, compensation and remedies sought in this class action.
				</li>
			</ul>

			<p>
				To register on a confidential, no-cost, no-obligation basis, please complete the following registration
				form.
			</p>
		</div>
	</div>
	<div class="row justify-content-md-center">
		<div class="col-md-8 col-sm-12 text-center">
			<NavigationButtons
				showPrevious="false"
				{nextPage}
				nextPageLabel="REGISTER FOR THE CLASS ACTION"
				verifyCaptcha="true"
				tealiumTag={false}
				pageName={title}
				onNext={registerFormStart}
			/>
		</div>
		<div class="col-md-8 col-sm-12 text-center">
			<div class="recaptcha">
				<div id="g-recaptcha" data-sitekey={projectSettings.gSiteKey2}></div>
			</div>
		</div>
	</div>
	<div class="row justify-content-md-center" style="margin-top: 12px;">
		<div class="col-md-8 col-sm-12">
			<!--  <p>
        Not sure if you are eligible to register? See the McDonald's Breaks Class Action website for more information
        <a
          href="{projectSettings.servicePageUrl}"
          title="McDonald's Breaks Class Action web page"
          target="_blank"
          rel="noreferrer noopener">here</a
        > or contact us.
      </p> -->
			<p>
				If you require support completing your registration, please contact Shine Lawyers on
				<ClassActionPhoneNumber></ClassActionPhoneNumber> or via email to
				<ClassActionEmailAddress></ClassActionEmailAddress>.
			</p>
		</div>
	</div>
</PageSection>

<style>
	h1 {
		margin-bottom: 20px;
	}

	h2 {
		font-size: 1.1em;
		margin-bottom: 16px;
	}

	h2 {
		font-weight: 700;
	}

	.recaptcha {
		padding-top: 20px;
		display: flex;
		justify-content: center;
	}
</style>
